import { ArrowBackIcon, RepeatIcon, WarningIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Icon,
  Stack,
  Text
} from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { userTypeRedirect } from "components/login-page/functions";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect } from "react";
import { RoutePermissionFunction, useRouter } from "router-manager/parts";

function BlockedUserPage() {
  const { user } = useApplicationContext();
  const router = useRouter();

  useEffect(() => {
    router.push(userTypeRedirect(user));
  }, []);

  const licencaExpirada = !!user?.userData.customerLicenseUserExpired;
  const quantidadeContratadaExcedida =
    !!user?.userData.customerLicenseUserQtyExceeded;

  const messageScreen = licencaExpirada
    ? [
        "Licença de usuários expirada!",
        "Contate o usuário MASTER para regularização."
      ]
    : quantidadeContratadaExcedida
      ? [
          "Quantidade de usuários Vendedor/Operacional ativos excedida para a sua licença!",
          "Contate o usuário MASTER para regularização."
        ]
      : [
          "Seu acesso está temporariamente bloqueado.",
          "Contate o usuário MASTER para regularização."
        ];

  return (
    <GetLayout>
      <Center
        flexDirection="column"
        h="100%"
        w="100%"
        justifyContent="space-around"
        px={4}
      >
        <Box
          w="100%"
          maxW="780px"
          bg="white"
          borderRadius="12px"
          border="1px solid #E2E8F0"
          boxShadow="xl"
          p={{ base: "24px", md: "32px" }}
        >
          <Stack spacing={6}>
            <Stack spacing={3} align="center" textAlign="center">
              <Icon as={WarningIcon} boxSize={8} color="#D97706" />
              <Heading size="md" color="#1A202C">
                Acesso bloqueado
              </Heading>
            </Stack>

            <Box
              bg="#FFFBEB"
              border="1px solid #FBD38D"
              borderRadius="10px"
              p={4}
            >
              <Flex direction="column">
                {messageScreen.map((message) => (
                  <Text
                    key={message}
                    fontWeight="medium"
                    color="#bb6605"
                    lineHeight="1.5"
                    textAlign="center"
                  >
                    {message}
                  </Text>
                ))}
              </Flex>
            </Box>

            <Button
              leftIcon={<RepeatIcon boxSize="4" />}
              onClick={() => window.location.reload()}
              w="100%"
              color="white"
            >
              Verificar licença novamente
            </Button>
          </Stack>
        </Box>
        <Box></Box>
      </Center>
    </GetLayout>
  );
}

export default BlockedUserPage;

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => {
    return user?.userData.type === "PARCEIRO_VENDEDOR";
  });
};
